import { render, staticRenderFns } from "./active-vacancies.vue?vue&type=template&id=61631c19&"
import script from "./active-vacancies.vue?vue&type=script&lang=js&"
export * from "./active-vacancies.vue?vue&type=script&lang=js&"
import style0 from "./active-vacancies.vue?vue&type=style&index=0&id=61631c19&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports